
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/group-solution",
      function () {
        return require("private-next-pages/group-solution.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/group-solution"])
      });
    }
  